<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import http from "@common/js/tools/http.js";
export default {
  name: "app",
  mounted() {
    this.$nextTick(() => {
      this.getAppStyle();
    });
    // try {
    //   window.initRecordSDK({
    //     env: process.env.VUE_APP_SCRIPT_ENV,
    //   });
    // } catch (error) {
    //   window.console.log(error);
    // }
  },
  methods: {
    getAppStyle() {
      const url = "nanfang_if/app/getAppStyle";
      http.get(url, {}).then((result) => {
        if (result.code === 200) {
          this.getDetailsStyle(result.data);
        }
      });
    },
    getDetailsStyle(appStyleInfo) {
      const domEl = document.getElementsByTagName("html")[0];
      if (appStyleInfo && +appStyleInfo.themeType === 1) {
        // 全局黑白
        if (this.hasClass(domEl, "notgrayscale")) {
          this.removeClass(domEl, "notgrayscale");
        }
        this.addClass(domEl, "grayscale");
      } else {
        // 全局彩色
        if (this.hasClass(domEl, "grayscale")) {
          this.removeClass(domEl, "grayscale");
        }
        this.addClass(domEl, "notgrayscale");
      }
    },
    hasClass(curEle, className) {
      var reg = new RegExp("(^| +)" + className + "( +|$)");
      return reg.test(curEle.className);
    },
    addClass(curEle, className) {
      var arr = className.replace(/(^ +| +$)/g, "").split(/ +/g); // 先去首尾空格，为了防止className为多个类名 "box1 box2"
      for (var i = 0, len = className.length; i < len; i++) {
        var curName = arr[i];
        if (!this.hasClass(curEle, className)) {
          if (i === 0) {
            curEle.className += "" + curName;
          } else {
            curEle.className += " " + curName;
          }
        }
      }
    },
    removeClass(curEle, className) {
      var arr = className.replace(/(^ +| +$)/g, "").split(/ +/g);
      for (var i = 0, len = className.length; i < len; i++) {
        var curName = arr[i];
        if (this.hasClass(curEle, curName)) {
          var reg = new RegExp("(^| +)" + curName + "( +|$)", "g");
          curEle.className = curEle.className.replace(reg, " ");
        }
      }
    },
  },
};
</script>

<style lang="scss">
#app {
  height: 100%;
  width: 100%;
  background: #ffffff;
}
</style>
